import BasicCard from '../../../components/basicCard/BasicCard';

interface IAnalysisListCard {
  title: string;
  subTilte: string;
  list: JSX.Element[];
  filter?: JSX.Element;
}
const AnalysisListCard = (props: IAnalysisListCard) => {

  const { title , subTilte, list, filter } = props;
  return (
  <BasicCard radius="md">
    <div className='p-6 !h-full'>
      <div className='flex justify-between items-center mb-4'>
        <div>
          <h2 className='text-headings-font-color text-lg md:text-xl font-semibold'>{title}</h2>
          <h5 className='text-font-color text-sm md:text-md mt-4'>{subTilte}</h5>
        </div>
        {filter && (
          <div className='flex-shrink-0'>
            {filter}
          </div>
        )}
      </div>

      <div className='mt-6'>
        {list.map((item: JSX.Element, index: number) => (
          <div key={index} className='mb-2'>
            {item}
          </div>
        ))}
      </div>
    </div>
  </BasicCard>
  );
};

export default AnalysisListCard;
